<!-- <div *ngIf="page">
	<div class="flex justify-content-center mt-2" >
		<img src="/assets/logo_essen.jpg" class="border-circle mr-4">
		<h1>{{page.title_fr}}</h1>
	</div>

	<p [innerHtml]="page.text_fr" class="text-justify">

	</p>

	<div class="grid mt-4">
		<div class="sm:col-6 md:col-3 col-12" *ngFor="let block of page.products; let i=index" >
			<app-bloc-game [game]="block.game" [view]="'gridView'" [preorder]="block.priceAfter"></app-bloc-game>
		</div>
	</div>

	<div class="white p-4" [hidden]="send">
		<form class="grid form" #orderForm="ngForm">
			<div class="col-12 md:col-6 lg:col-6 xl:col-6">
				<div class="md-form md-outline">
					<label for="firstname">{{'firstname' | translate}} *</label>        
					<input type="text" pInputText [(ngModel)]="order.firstname" name="firstname" id="firstname" required class="form-control">
				</div>
			</div>
			<div class="col-12 md:col-6 lg:col-6 xl:col-6">
				<div class="md-form md-outline">
					<label for="lastname">{{'lastname' | translate}} *</label>        
					<input type="text" pInputText [(ngModel)]="order.lastname" name="lastname" required id="lastname" class="form-control">
				</div>
			</div>
			<div class="col-12 md:col-6 lg:col-6 xl:col-6">
				<div class="md-form md-outline">
					<label for="phone">{{'phone' | translate}} *</label>         
					<input type="text" pInputText id="phone" [(ngModel)]="order.tel" name="tel" required class="form-control">
				</div>
			</div>
			<div class="col-12 md:col-6 lg:col-6 xl:col-6">
				<div class="md-form md-outline" >
					<label for="email">{{'email' | translate}} *</label>         
					<input type="text" pInputText id="email" [(ngModel)]="order.email" name="email" required class="form-control">         
				</div>
			</div>
		</form>
		<div class="grid my-2 border-bottom-1" *ngFor="let block of page.products; let i=index" [hidden]="!block.pages || block.pages.indexOf(language) === -1" >
			<div class="col-4">
				{{block.game.name_item}}
				<div style="font-size: 12px;" *ngIf="false && (block.game.id_item == '881' || block.game.id_item == '834' || block.game.id_item == '963')">
					<div>French box with rules in english</div>
					<div *ngIf="block.game.id_item == '963'">French box with rules in german</div>
				</div>
				<div  style="font-size: 12px;" *ngIf="false && block.game.id_item == '940'">French/English box with rules in german</div>

			</div>
			<div *ngIf="block.languages" class="col-6 flex justify-content-center align-items-center gap-3">
				<div *ngFor="let l of orderBy(block.languages)" class="flex justify-content-center align-items-center">
					<img class="flag" src="assets/country/png250px/{{l}}.png" >
					<p-inputNumber inputStyleClass="w-4rem" [showButtons]="true" type="number" (onInput)="chooseProd($event,block,l)" value="0"></p-inputNumber>
				</div>
			</div>
			<div class="col-2 text-right">{{block.priceAfter}} €</div>
		</div>
		<div class="text-right font-weight-bold">
			Réduction : {{order.reduc | currency:'EUR'}}
		</div>
		<div class="text-right font-weight-bold">
			TOTAL : {{order.total | currency:'EUR'}}
		</div>
		<div class="md-form md-outline" >
			<label for="form7">{{'additionnal information' | translate}}</label>
			<textarea type="text" id="form7" class="md-textarea form-control" pInputTextarea [(ngModel)]="order.notes" name="notes" style="min-height: 100px;"></textarea>
		</div>
		<div class="text-right">
			Merci de compléter tous les champs obligatoires (*)
			<button type="button" pButton color="success" mdbWavesEffect (click)="save()" [disabled]="orderForm.invalid || order.products.length < 1">Précommander</button>
		</div>		
	</div>
	<div class="white p-4" *ngIf="send">
		<div class="alert alert-success" role="alert" >
			<h4>{{'order save' | translate}}</h4> 
			<hr>
			{{'email send' | translate }}
			<button type="button" pButton color="secondary" mdbWavesEffect (click)="send = false;" >Retour</button>
		</div>
	</div>
</div>
 -->
	<script>
		window.addEventListener("scroll", function (event) {
			document.getElementById('my-shoop').contentWindow.postMessage({ type: 'scroll', scrollY: window.scrollY, clientRect: document.getElementById('my-shoop').getBoundingClientRect() }, '*');
		});
		window.addEventListener('message', function (event) {
			if (height = event.data['height']) {
				document.getElementById('my-shoop').style.height = height + event.data['footerHeight'] + 20 + 'px';
			}
		});
	</script>
	<iframe frameBorder="0" allowTransparency="true" type="text/html" id="my-shoop" src="https://blackrock-games.my-shoop.store/?iframe=true&full=no" width="100%" ></iframe>